import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PLOT_TOPICS } from "../lib/content";
import { BRAND } from "../lib/brand";
import MiniLeadForm from "../components/MiniLeadForm";

export default function Plots() {
  return (
    <div data-testid="plots-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="text-xs uppercase tracking-widest text-[#1D4ED8]">Plots & Land</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-4xl leading-[1.1]">In India's growth corridors — where infrastructure creates real demand.</h1>
        <p className="text-lg text-zinc-600 mt-8 max-w-3xl leading-relaxed">
          Plot investment in growth corridors is one of the most powerful wealth-building strategies in Indian real estate — when done right. The problem is that most people don't.
        </p>
        <p className="text-zinc-700 mt-4 max-w-3xl leading-relaxed">
          Zentry covers only verified opportunities — locations where government-backed infrastructure is creating real demand. We only work with RERA-registered developers.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-4">
        {BRAND.plotsImages.map((src, i) => (
          <div key={i} className="rounded-3xl overflow-hidden border border-zinc-200 aspect-[16/10]">
            <img src={src} alt="" className="w-full h-full object-cover" />
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <h2 className="font-display text-4xl sm:text-5xl tracking-tight max-w-3xl">What you need to understand</h2>
        <p className="text-zinc-600 mt-4 max-w-2xl">Each topic has a dedicated page. Start with whichever matters most.</p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PLOT_TOPICS.map((t) => (
            <Link key={t.slug} to={`/plots/${t.slug}`} className="group bg-white border border-zinc-200 rounded-2xl p-7 hover:border-[#1D4ED8] hover:-translate-y-1 transition-all" data-testid={`plot-topic-${t.slug}`}>
              <div className="text-xs uppercase tracking-widest text-[#1D4ED8]">{t.kicker}</div>
              <h3 className="font-display text-2xl mt-2 leading-snug">{t.title}</h3>
              <p className="text-zinc-600 mt-3 text-sm line-clamp-3">{t.summary}</p>
              <div className="mt-5 inline-flex items-center gap-1 text-[#1D4ED8] text-sm font-medium">Read <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></div>
            </Link>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-20">
        <MiniLeadForm
          context="plot"
          title="Curious about which corridor fits your goal?"
          sub="The corridors we cover, our active filters, and current opportunities — all of this is shared on the Clarity Call. Leave your number and we'll call you back."
        />
      </section>
    </div>
  );
}
